"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStagingCheck = exports.useTestCheck = exports.useLocalCheck = exports.useProdCheck = void 0;
// To be used only with EnvProvider
const provider_1 = require("./provider");
const useProdCheck = () => {
    const env = (0, provider_1.useEnv)();
    return env.ENVIRONMENT === "production";
};
exports.useProdCheck = useProdCheck;
const useLocalCheck = () => {
    const env = (0, provider_1.useEnv)();
    return env.ENVIRONMENT === "local";
};
exports.useLocalCheck = useLocalCheck;
const useTestCheck = () => {
    const env = (0, provider_1.useEnv)();
    return env.ENVIRONMENT === "test";
};
exports.useTestCheck = useTestCheck;
const useStagingCheck = () => {
    const env = (0, provider_1.useEnv)();
    return env.ENVIRONMENT === "staging";
};
exports.useStagingCheck = useStagingCheck;
//# sourceMappingURL=hooks.js.map